import styled from 'styled-components';
import { Icon, IconName, IconSize } from '@ardoq/icons';
import {
  ReferenceAddressItem,
  ReferenceAddressItemRelationType,
} from './types';
import { s4, s8 } from '@ardoq/design-tokens';
import { text2, text2Bold } from '@ardoq/typography';
import { GroupType } from '@ardoq/api-types';

const relationTypeTooltip = ({
  relation,
  relationGroupType,
}: Pick<ReferenceAddressItem, 'relation' | 'relationGroupType'>) => {
  switch (relation) {
    case ReferenceAddressItemRelationType.WORKSPACE:
      return 'grouped by workspace';
    case ReferenceAddressItemRelationType.REFERENCE:
    case ReferenceAddressItemRelationType.REFERENCE_GROUP:
      return 'reference';
    case ReferenceAddressItemRelationType.CHILD:
      switch (relationGroupType) {
        case GroupType.PARENT_ALL:
          return 'grouped by parent all';
        case GroupType.PARENT:
          return 'grouped by parent';
      }
      break;
    case ReferenceAddressItemRelationType.GROUP_MEMBER:
      switch (relationGroupType) {
        case GroupType.TAG:
          return 'grouped by tag';
        case GroupType.COMPONENT:
          return 'grouped by component type';
        case GroupType.FIELD:
          return 'grouped by field';
        case GroupType.REFERENCE:
          return 'grouped by reference type';
      }
      break;
  }
};

const relationTypeToIconName = (
  relationType: ReferenceAddressItemRelationType
) => {
  switch (relationType) {
    case ReferenceAddressItemRelationType.WORKSPACE:
      return IconName.WORKSPACE;
    case ReferenceAddressItemRelationType.REFERENCE:
    case ReferenceAddressItemRelationType.REFERENCE_GROUP:
      return IconName.REFERENCE;
    case ReferenceAddressItemRelationType.CHILD:
      return IconName.PARENT_CHILD;
    default:
    case ReferenceAddressItemRelationType.GROUP_MEMBER:
      return IconName.FORMAT_LIST_BULLETED;
  }
};

const Label = styled.label<{ $isNodeHidden: boolean }>`
  display: inline;
  vertical-align: middle;
  font-weight: normal;
  margin-right: ${s4};
  ${({ $isNodeHidden }) => ($isNodeHidden ? '' : text2Bold)}
`;
const List = styled.ul`
  padding: 0;
  margin: ${s8} 0 ${s4} 0;
  ${text2};
  max-width: 304px;
`;
const ListItem = styled.li`
  display: inline;
`;
const RelationIcon = styled(Icon).attrs({ iconSize: IconSize.SMALL })`
  margin-right: ${s4};
  vertical-align: middle;
`;
interface ReferenceAddressProperties {
  address: ReferenceAddressItem[];
}
const ReferenceAddressComponent = ({ address }: ReferenceAddressProperties) => (
  <List>
    {address.map(
      (
        { nodeInfo: { name, isHidden }, relation, relationGroupType },
        index
      ) => (
        <ListItem key={`${name}_${index}`}>
          <Label $isNodeHidden={isHidden}>{name}</Label>
          {relation !== ReferenceAddressItemRelationType.SELF && (
            <RelationIcon
              iconName={relationTypeToIconName(relation)}
              data-tooltip-text={relationTypeTooltip({
                relation,
                relationGroupType,
              })}
            />
          )}
        </ListItem>
      )
    )}
  </List>
);
export { ReferenceAddressComponent };
